import { apiEmpleo } from "../../util/ApiEmpleo";
import { TStaffUserResponse } from "./apiListStaffUsers";

const apiGetStaffUser = async (ownerId: string) => {
  let res: TStaffUserResponse = await apiEmpleo.get(`users/${ownerId}`);
  return res;
};

export { apiGetStaffUser };
